module.exports = __webpack_public_path__ + "img/emoji-note-book@3x.d649694.png";